module.exports = __webpack_public_path__ + "img/snapchat.6a4999a3.svg";